<template>
  <el-dialog
    title="系统编辑"
    :visible.sync="dialogShow"
    @close="closeDialog"
    @open="openDialog"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="系统编号" :label-width="formLabelWidth" prop="id">
        <el-input
          v-model="form.id"
          autocomplete="off"
          placeholder="请输入系统编号"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="系统名称"
        :label-width="formLabelWidth"
        prop="systemName"
      >
        <el-input
          v-model="form.systemName"
          autocomplete="off"
          placeholder="请输入系统名称"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveSystem">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SystemEdit",
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },
  data() {
    return {
      dialogShow: this.show,
      form: {
        id: "",
        systemName: "",
      },
      formLabelWidth: "120px",
      rules: {
        id: [
          { required: true, message: "请输入系统编号", trigger: "blur" },
          { min: 4, max: 10, message: "请输入4到10个数字", trigger: "blur" },
        ],
        systemName: [
          { required: true, message: "请输入系统名称", trigger: "blur" },
          { min: 4, max: 20, message: "请输入6到20个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    openDialog() {
      if (this.formData != null) {
        this.form.id = this.formData.id;
        this.form.systemName = this.formData.systemName;
      } else {
        this.form.id = "";
        this.form.systemName = "";
      }
    },
    closeDialog() {
      this.dialogShow = false;
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },

    saveSystem() {
      if (this.action === "addSystem") {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.axios
              .post("/sysSystemInfo/saveSystem", this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "添加成功",
                    message: res.msg,
                    type: "success",
                  });

                  this.$bus.$emit("refresh"); //通知刷新

                  this.closeDialog();
                } else {
                  this.$notify.error({
                    title: "添加失败",
                    message: res.msg,
                  });
                }
              });
          } else {
            return false;
          }
        });
      }

      if (this.action === "editSystem") {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.axios
              .post("/sysSystemInfo/editSystem", this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "提示",
                    message: res.msg,
                    type: "success",
                  });

                  this.$bus.$emit("refresh"); //通知刷新

                  this.closeDialog();
                } else {
                  this.$notify.error({
                    title: "提示",
                    message: res.msg,
                  });
                }
              });
          } else {
            return false;
          }
        });
      }
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    },
  },
};
</script>

<style scoped>
</style>